import { Link } from "react-router-dom";
import { FormActions } from "../../components/common/FormActions";
import {
  createViewEdit,
  NoWrap,
  numberFormat,
  returnObject,
} from "../../utils/helpers";

export const useCompositeItems = () => {
  const tableColumns = () => [
    {
      id: "payment_item",
      header: "Payment Item",
      filter: {
        type: "text",
      },
    },

    {
      id: "secondary_payment_item",
      header: "Secondary Payment Item",
      filter: {
        type: "text",
      },
    },
    {
      id: "merchant",
      header: "Merchant",
      filter: {
        type: "date",
      },
    },
    {
      id: "minimum_amount",
      header: "Minimum Amount",
      filter: {
        type: "text",
      },
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        payment_item: <NoWrap>{item?.payment_item}</NoWrap>,

        secondary_payment_item: <NoWrap>{item?.secondary_payment_item}</NoWrap>,
        merchant: <NoWrap>{item?.merchant}</NoWrap>,
        minimum_amount: <NoWrap>{item?.minimum_amount}</NoWrap>,
        actions: (
          <FormActions actions={createViewEdit("/composite_", item?.id)} />
        ),
      };
      return row;
    }),
  ];
  const externalFilters = [
    {
      id: "account",
      header: "Account",
      filter: { type: "text" },
    },
  ];

  const tableTotals = (data: any) => {
    return {
      amount: numberFormat(data?.metadata?.total_amount),
    };
  };

  const viewData = (item: any) => {
    return {
      ...returnObject(item?.content_type_model === "loanapplication", {
        loan_application: (
          <Link
            to={`/composite_items/view/${item?.object_id}`}
            className="link-text"
          >
            {item?.object_id}
          </Link>
        ),
      }),
      payment_item: item?.payment_item,

      secondary_payment_item: item?.secondary_payment_item,
      merchant: item?.merchant,
      minimum_amount: item?.minimum_amount,
    };
  };

  return {
    tableColumns,
    tableData,
    viewData,
    tableTotals,

    externalFilters,
  };
};
